/*
import HeaderTitle from './HeaderTitle';
import HeaderContainer from './HeaderContainer';

const DetailPageHeader = ({ title, image }) => {
	return (
		<HeaderContainer
			headerContent={
				<>
					<HeaderTitle image={image} alt={title} title={title} />
				</>
			}
		/>
	);
};

export default DetailPageHeader;
*/

import AddIcon from '@mui/icons-material/Add';
import { useState } from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';

const AutoIcon = () => {
	return (
		<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M9 4h6l1 6-3 2v7l-2-2-2 2v-7l-3-2 1-6Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
		</svg>
	);
};

const DetailPageHeader = ({
	title,
	image,
	actions,
	tabsItem,
	selectedTab,
	selectTabHandler,
	onCreateHandler,
	onAuto = () => {},
	showAuto = false,
	createBtn = false,
	activeCreateButton = false,
}) => {
	const [isAutoActive, setIsAutoActive] = useState(false);
	const [isHeaderPinned, setIsHeaderPinned] = useState(false);

	const handleTabClick = (event, index) => {
		if (typeof selectTabHandler !== 'function') return;

		if (selectTabHandler.length >= 2) {
			selectTabHandler(event, index);
		} else {
			selectTabHandler(index);
		}
	};

	const handleAutoClick = () => {
		const nextState = !isHeaderPinned;
		setIsAutoActive(nextState);
		setIsHeaderPinned(nextState);
		onAuto(nextState);
	};

	return (
		<Box
			sx={{
				mb: '22px',
				position: isHeaderPinned ? 'sticky' : 'static',
				top: isHeaderPinned ? '60px' : 'auto',
				zIndex: isHeaderPinned ? 999 : 'auto',
				backgroundColor: isHeaderPinned ? '#F8FAFC' : 'transparent',
			}}
		>
			<Box
				sx={{
					py: 1.75,
					borderRadius: '16px',
					px: { xs: 2, sm: 2.5 },
					backgroundColor: '#FFFFFF',
					border: '1px solid #E5E7EB',
					boxShadow: '0 1px 6px rgba(15, 23, 42, 0.05)',
				}}
			>
				<Stack
					direction={{ xs: 'column', lg: 'row' }}
					alignItems={{ xs: 'flex-start', lg: 'center' }}
					justifyContent="space-between"
					gap={1.5}
				>
					<Stack direction="row" alignItems="center" sx={{ gap: '10px' }}>
						{/* {image ? (typeof image === 'string' ? <img alt={title} src={image} width="20px" height="18px" /> : image) : null} */}
						<Typography sx={{ fontSize: '24px', lineHeight: 1.1, fontWeight: 600, color: '#1F2937' }}>{title}</Typography>
					</Stack>

					<Stack
						direction="row"
						alignItems="center"
						flexWrap="wrap"
						justifyContent={{ xs: 'flex-start', lg: 'flex-end' }}
						gap={1}
						width={{ xs: '100%', lg: 'auto' }}
					>
						{actions}

						{tabsItem?.length > 0 && (
							<Stack direction="row" alignItems="center" flexWrap="wrap" gap={0.5}>
								{tabsItem?.map((item, index) => {
									const isSelected = selectedTab === index;

									return (
										<Button
											key={`${item?.label}-${index}`}
											onClick={(event) => handleTabClick(event, index)}
											sx={{
												px: 2,
												fontSize: '15px',
												fontWeight: 500,
												minHeight: '42px',
												boxShadow: 'none',
												borderRadius: '10px',
												textTransform: 'none',
												color: isSelected ? '#FFFFFF' : '#475569',
												backgroundColor: isSelected ? '#0F172A' : 'transparent',
												'&:hover': {
													boxShadow: 'none',
													backgroundColor: isSelected ? '#0F172A' : '#F8FAFC',
												},
											}}
										>
											{item?.label}
										</Button>
									);
								})}
							</Stack>
						)}

						{showAuto && (
							<Button
								onClick={handleAutoClick}
								startIcon={<AutoIcon />}
								sx={{
									px: 2,
									fontSize: '15px',
									fontWeight: 500,
									height: '36px',
									borderRadius: '10px',
									textTransform: 'none',
									color: isAutoActive ? '#1D4ED8' : '#374151',
									border: `1px solid ${isAutoActive ? '#BFDBFE' : '#E5E7EB'}`,
									backgroundColor: isAutoActive ? '#EFF6FF' : '#FFFFFF',
								}}
							>
								{isAutoActive ? 'Pinned' : 'Auto'}
							</Button>
						)}

						{createBtn && (
							<Button
								onClick={onCreateHandler}
								disabled={activeCreateButton}
								startIcon={<AddIcon sx={{ fontSize: '18px' }} />}
								sx={{
									px: 2,
									fontSize: '15px',
									fontWeight: 500,
									color: '#FFFFFF',
									minHeight: '42px',
									borderRadius: '10px',
									textTransform: 'none',
									backgroundColor: '#1D4ED8',
									'&:hover': {
										backgroundColor: '#1E40AF',
									},
									'&.Mui-disabled': {
										color: '#E2E8F0',
										backgroundColor: '#93C5FD',
									},
								}}
							>
								Create
							</Button>
						)}
					</Stack>
				</Stack>
			</Box>
		</Box>
	);
};

export default DetailPageHeader;
